module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "structure-tree"
  }, [_c('td', {
    staticClass: "structure-user"
  }, [_vm._v("\n    " + _vm._s(_vm.user) + "\n  ")]), _vm._v(" "), _c('td', {
    staticClass: "structure-child"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', _vm._l((_vm.children), function(child) {
    return _c('PrintList', {
      attrs: {
        "children": child.children,
        "user": child.user
      }
    })
  }), 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e2ac5e3!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/StructurePrintList.vue
// module id = 1095
// module chunks = 0